var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('utils-ckeditor',{model:{value:(_vm.dataPrivacy),callback:function ($$v) {_vm.dataPrivacy=$$v},expression:"dataPrivacy"}}),_c('v-btn',{staticClass:"mt-3",on:{"click":_vm.setDataPrivacy}},[_vm._v("Сохранить")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }